import Service from './abstract';
import _ from 'lodash';
import page from '../constants/pages/page';

const defaultOptions = {
    order: 'created_at-DESC',
    tiny: false,
    pageSize: page.pageSize,
};

const defaultFraudControlException = {
    with: 'status'
};

class MakeAndChecker extends Service {
    constructor () {
        super('makeandchecker');
    }

    getActions (options = {}) {
        return this.get({
            url: `${this.basePath}/actions`,
            qs: _.defaultsDeep(options, defaultOptions)
        });
    }

    // endpoint para traer todas las excepciones de fraude
    getListFraudException (options) {
        return this.get({
            url: `${this.basePath}/fraudcontrol/exeptions`,
            qs: _.defaultsDeep(options, defaultOptions, defaultFraudControlException)
        });
    }

    createAction (data = {}) {
        return this.post({
            url: `${this.basePath}/actions`,
            data
        });
    }

    getBenefits (options = {}) {
        return this.get({
            url: `${this.basePath}/benefits/users`,
            qs: _.defaultsDeep({ tiny: false }, options)
        });
    }

    getBills (options = {}) {
        return this.get({
            url: `${this.basePath}/afip/bills`,
            qs: _.defaultsDeep({ tiny: false }, options)
        });
    }
}

export default new MakeAndChecker();
